(function(){
  /* ================= CARRITO: aviso inmediato, confirmacion por detras ================= */
  function toast(msg){
    var t=document.getElementById('laf-toast');
    if(!t){t=document.createElement('div');t.id='laf-toast';t.className='laf-toast';document.body.appendChild(t);}
    t.textContent=msg;t.classList.add('show');
    clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('show');},2200);
  }
  document.addEventListener('click',function(e){
    if(window.lafCart)return; /* el carrito unificado (laf-cart.js) se encarga */
    var b=e.target.closest('.laf-add[data-variant-id]');if(!b||b.disabled)return;
    e.preventDefault();var id=b.getAttribute('data-variant-id');if(!id){toast('Producto no disponible');return;}
    var old=b.textContent;b.disabled=true;
    b.textContent='✓';toast('Añadido a la cesta');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){return r.json().then(function(data){return {status:r.status,data:data};});})
      .then(function(res){
        if(res.status!==200){throw new Error((res.data&&(res.data.description||res.data.message))||'Error '+res.status);}
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function(err){toast(err&&err.message?err.message:'No se pudo añadir');document.dispatchEvent(new CustomEvent('cart:refresh'));})
      .then(function(){setTimeout(function(){b.textContent=old;b.disabled=false;},900);});
  });

  /* ================= FILTROS / CATEGORIAS / CARGAR MAS ================= */
  try{
    var SVG_UP='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg>';
    var SVG_DOWN='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
    function panel(){return document.getElementById('main-search-filters');}
    function openFacets(){var e=document.querySelectorAll('.facets__disclosure-vertical');for(var i=0;i<e.length;i++){e[i].open=true;}}
    function openMobileFacets(){var e=document.querySelectorAll('.mobile-facets__details');for(var i=0;i<e.length;i++){e[i].open=true;}}
    function positionHead(fbox,head){
      var isMobile=window.matchMedia('(max-width:749px)').matches;
      if(isMobile){var a=fbox.querySelector('.mobile-facets__wrapper');if(a){if(a.nextElementSibling!==head){a.insertAdjacentElement('afterend',head);}return;}}
      if(fbox.firstElementChild!==head){fbox.insertBefore(head,fbox.firstChild);}
    }
    /* Movil: bajo "Filtrar y ordenar" va una copia de la MISMA barra del home
       (mismo aspecto y mismo desplegable a pantalla completa al escribir) */
    function makeSearchClone(q){
      var src=document.querySelector('.laf-search[data-laf-ps]:not(.laf-search--clone)');if(!src)return null;
      var c=src.cloneNode(true);
      c.classList.add('laf-search--clone');c.classList.remove('is-open','is-loading');
      var p=c.querySelector('.laf-ps');if(p){p.id='laf-ps-panel-res';p.hidden=true;}
      var live=c.querySelector('.laf-ps__live');if(live){live.innerHTML='';live.hidden=true;}
      var def=c.querySelector('.laf-ps__default');if(def){def.hidden=false;}
      var inp=c.querySelector('.laf-search__input');if(inp){inp.value=q;inp.setAttribute('aria-controls','laf-ps-panel-res');inp.setAttribute('aria-expanded','false');}
      return c;
    }
    function injectFilterSearch(){
      var fbox=panel();if(!fbox)return;
      var head=fbox.querySelector('.laf-fhead');
      if(!head){
        var q='';try{q=new URLSearchParams(window.location.search).get('q')||'';}catch(e){}
        head=document.createElement('div');head.className='laf-fhead';
        head.innerHTML='<button type="button" class="laf-fnav laf-fnav--up" aria-label="Subir en los filtros">'+SVG_UP+'</button>';
        var c=makeSearchClone(q);
        if(c){head.insertBefore(c,head.firstChild);if(window.lafPS){window.lafPS.init(c);}}
        fbox.insertBefore(head,fbox.firstChild);
      }
      positionHead(fbox,head);
    }
    function injectNav(){
      var fbox=panel();if(!fbox)return;
      var down=fbox.querySelector('.laf-fnav--down');
      if(!down){down=document.createElement('button');down.type='button';down.className='laf-fnav laf-fnav--down';down.setAttribute('aria-label','Bajar en los filtros');down.innerHTML=SVG_DOWN;}
      if(fbox.lastElementChild!==down){fbox.appendChild(down);}
      if(!fbox.__lafScroll){fbox.__lafScroll=true;fbox.addEventListener('scroll',updateNav,{passive:true});}
      updateNav();
    }
    function updateNav(){
      var fbox=panel();if(!fbox)return;
      var up=fbox.querySelector('.laf-fnav--up');var down=fbox.querySelector('.laf-fnav--down');
      var max=fbox.scrollHeight-fbox.clientHeight;var over=max>4;
      if(up){up.style.visibility=over?'visible':'hidden';up.classList.toggle('is-off',fbox.scrollTop<=2);}
      if(down){down.style.visibility=over?'visible':'hidden';down.classList.toggle('is-off',fbox.scrollTop>=max-2);}
    }
    document.addEventListener('click',function(e){
      var n=e.target.closest('.laf-fnav');var fbox=panel();
      if(n&&fbox){e.preventDefault();fbox.scrollBy({top:(n.classList.contains('laf-fnav--up')?-240:240),behavior:'smooth'});return;}
      if(fbox&&fbox.contains(e.target)){setTimeout(updateNav,80);}
    });
    function injectSort(){
      var form=document.getElementById('FacetFiltersForm');if(!form||form.querySelector('.laf-sort'))return;
      var src=document.querySelector('select[name="sort_by"]');if(!src)return;
      var wrap=document.createElement('div');wrap.className='laf-sort';
      var lbl=document.createElement('label');lbl.className='laf-sort__lb';lbl.textContent='Ordenar por';wrap.appendChild(lbl);
      var sel=src.cloneNode(true);sel.removeAttribute('id');sel.className='laf-sort__sel';wrap.appendChild(sel);
      var price=form.querySelector('.facets__price');var pd=price?price.closest('.facets__disclosure-vertical'):null;
      if(pd){pd.insertAdjacentElement('afterend',wrap);}
      else{var fd=form.querySelector('.facets__disclosure-vertical');if(fd){fd.insertAdjacentElement('beforebegin',wrap);}else{form.insertBefore(wrap,form.firstChild);}}
    }
    /* Movil: la lista de marcas muestra 10 y un 'Mostrar mas' */
    function collapseMobileBrands(){
      var lists=document.querySelectorAll('#FacetsWrapperMobile .mobile-facets__list');
      for(var i=0;i<lists.length;i++){
        var l=lists[i];var n=l.querySelectorAll('.mobile-facets__item').length;
        if(n<=12||l.__lafDone)continue;l.__lafDone=true;l.classList.add('laf-collapsed');
        var b=document.createElement('button');b.type='button';b.className='laf-more-brands';
        b.textContent='Mostrar más ('+(n-10)+')';
        b.addEventListener('click',(function(list,btn,total){return function(ev){ev.preventDefault();var c=list.classList.toggle('laf-collapsed');btn.textContent=c?'Mostrar más ('+(total-10)+')':'Mostrar menos';};})(l,b,n));
        l.insertAdjacentElement('afterend',b);
      }
    }
    function refreshFilters(){openFacets();openMobileFacets();injectFilterSearch();injectSort();injectNav();collapseMobileBrands();}
    refreshFilters();
    document.addEventListener('DOMContentLoaded',refreshFilters);
    window.addEventListener('load',updateNav);
    var fb=panel();
    if(fb&&window.MutationObserver){new MutationObserver(function(){refreshFilters();}).observe(fb,{childList:true,subtree:true});}
    var rz;window.addEventListener('resize',function(){clearTimeout(rz);rz=setTimeout(function(){injectFilterSearch();updateNav();},150);});
    var cats=document.querySelector('.laf-cats');var arrow=document.querySelector('.laf-cats-arrow');
    if(cats&&arrow){cats.addEventListener('scroll',function(){arrow.style.opacity=(cats.scrollLeft+cats.clientWidth>=cats.scrollWidth-8)?'0':'1';});}
    /* "Cargar mas" escuchado desde el documento: al filtrar (p. ej. por precio) Dawn cambia la grilla
       y el boton es otro; antes ese boton nuevo ya no cargaba nada (Clau 16 oct 2026). */
    if(!window.__lafMoreDoc){
      window.__lafMoreDoc=true;
      document.addEventListener('click',function(ev){
        var moreBtn=ev.target&&ev.target.closest?ev.target.closest('[data-laf-more]'):null;
        if(!moreBtn||moreBtn.disabled)return;
        // Primero se revelan las tarjetas que ya estan en el HTML pero
        // ocultas (".lf-extra-hidden", ver sections/main-search.liquid: el
        // lote de resultados nativos de Shopify trae mas de 12 productos
        // visibles y los que sobran quedan ya renderizados, solo ocultos).
        // Asi "Cargar mas" se siente instantaneo mientras queden; recien
        // cuando se agotan se pide la siguiente pagina por AJAX.
        var hiddenExtras=document.querySelectorAll('#lf-grid-normal .lf-extra-hidden');
        if(hiddenExtras.length){
          for(var i=0;i<hiddenExtras.length && i<12;i++){
            hiddenExtras[i].removeAttribute('hidden');
            hiddenExtras[i].classList.remove('lf-extra-hidden');
          }
          var stillHidden=document.querySelectorAll('#lf-grid-normal .lf-extra-hidden').length;
          if(!stillHidden && !moreBtn.getAttribute('data-next-url') && moreBtn.parentNode){
            moreBtn.parentNode.removeChild(moreBtn);
          }
          return;
        }
        var url=moreBtn.getAttribute('data-next-url');if(!url)return;
        moreBtn.disabled=true;var old=moreBtn.textContent;moreBtn.textContent='Cargando…';
        fetch(url,{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.text();}).then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          // Se mergean las dos grillas por id (normal Y medicamentos, esta
          // ultima oculta tras el checkbox "Mostrar medicamentos") en vez de
          // solo la primera ".lafc-grid": si no se hace asi, los
          // medicamentos que trae la siguiente pagina quedan sin mostrarse
          // nunca (ni ocultos ni visibles), se pierden.
          ['lf-grid-normal','lf-grid-meds'].forEach(function(gridId){
            var newGrid=doc.getElementById(gridId);var g=document.getElementById(gridId);
            if(newGrid&&g){while(newGrid.firstElementChild){var nc=newGrid.firstElementChild;var hh=window.__lafCardHandle?window.__lafCardHandle(nc):'';if(hh&&window.__lafTopSet&&window.__lafTopSet[hh]){newGrid.removeChild(nc);continue;}g.appendChild(nc);}}
          });
          var newBtn=doc.querySelector('[data-laf-more]');
          if(newBtn){moreBtn.setAttribute('data-next-url',newBtn.getAttribute('data-next-url'));moreBtn.disabled=false;moreBtn.textContent=old;}
          else if(moreBtn.parentNode){moreBtn.parentNode.removeChild(moreBtn);}
        }).catch(function(){moreBtn.disabled=false;moreBtn.textContent=old;});
      });
    }
  }catch(err){}

  /* ================= FILTRO DE PRECIO (Clau 16 oct 2026) ================= */
  /* Al escribir un precio en "De"/"Hasta" se busca solo (Dawn lo hace a los 0,8 s de dejar de
     escribir, assets/facets.js) y ahora los productos salen ordenados de MENOR a MAYOR precio:
     se marca "price-ascending" en todos los "Ordenar por" antes de que salga esa busqueda. */
  try{
    document.addEventListener('input',function(e){
      var t=e.target;if(!t||!t.closest||!t.closest('price-range'))return;
      var sels=document.querySelectorAll('select[name="sort_by"], #LafOrdenCab');
      for(var i=0;i<sels.length;i++){if(sels[i].querySelector('option[value="price-ascending"]')){sels[i].value='price-ascending';}}
    },true);
    /* Tras cada busqueda de filtros (tambien al volver atras): el "N productos" junto al titulo de la
       categoria sigue al filtro (antes se quedaba en el total) y los "Ordenar por" que Dawn no repinta
       (el de la cabecera y la copia del cuadro) muestran el orden real de lo que se ve. */
    var lafCuenta=document.getElementById('ProductCountDesktop')||document.getElementById('ProductCount');
    if(lafCuenta&&window.MutationObserver){
      new MutationObserver(function(){
        var cab=document.querySelector('.laf-cab-cuenta');
        var m=(lafCuenta.textContent||'').match(/\d[\d.]*/);
        if(cab&&m){var txt=m[0]+(m[0]==='1'?' producto':' productos');if(cab.textContent!==txt){cab.textContent=txt;}}
        var src=document.getElementById('SortBy')||document.getElementById('SortBy-mobile');var v=src&&src.value;
        if(v){var otros=document.querySelectorAll('#LafOrdenCab, .laf-sort__sel');for(var i=0;i<otros.length;i++){if(otros[i].value!==v&&otros[i].querySelector('option[value="'+v+'"]')){otros[i].value=v;}}}
      }).observe(lafCuenta,{childList:true,characterData:true,subtree:true});
    }
  }catch(err){}

  /* ================= LO QUE SE VIO EN LA VISTA PREVIA VA PRIMERO ================= */
  /* "Mostrar mas resultados" (assets/laf-buscador.js) agrega a la URL
     lf_top=handle1,handle2,... con los productos que el cliente acaba de ver
     en la vista previa. Aca se ponen PRIMERO en la grilla (sin repetirlos) y
     despues siguen los demas resultados: nada de lo que se vio desaparece. */
  try{
    window.__lafCardHandle=function(card){
      var a=card&&card.querySelector?card.querySelector('a[href*="/products/"]'):null;if(!a)return '';
      var m=a.getAttribute('href').match(/\/products\/([^\/?#]+)/);return m?decodeURIComponent(m[1]):'';
    };
    var topParam='';try{topParam=new URLSearchParams(window.location.search).get('lf_top')||'';}catch(e){}
    var topHandles=topParam.split(',').map(function(h){return h.trim();}).filter(function(h){return /^[a-z0-9][a-z0-9\-_.%]*$/i.test(h);}).slice(0,12);
    if(topHandles.length){
      window.__lafTopSet={};topHandles.forEach(function(h){window.__lafTopSet[h]=1;});
      var runTop=function(){
        var grid=document.getElementById('lf-grid-normal');if(!grid||grid.__lafTop)return;grid.__lafTop=true;
        var pedidos=topHandles.map(function(h){
          var ctrl=window.AbortController?new AbortController():null;
          var t=setTimeout(function(){if(ctrl)ctrl.abort();},5000);
          return fetch('/products/'+encodeURIComponent(h)+'?view=lfcard',{signal:ctrl?ctrl.signal:undefined})
            .then(function(r){clearTimeout(t);return r.ok?r.text():'';})
            .catch(function(){clearTimeout(t);return '';});
        });
        Promise.all(pedidos).then(function(textos){
          var nuevos=[];
          textos.forEach(function(txt,i){
            if(!txt)return;
            var d=document.createElement('div');d.innerHTML=txt;
            var card=d.querySelector('.laf-card');if(!card)return;
            if(window.__lafCardHandle(card).toLowerCase()!==topHandles[i].toLowerCase())return;
            nuevos.push({h:topHandles[i].toLowerCase(),card:card});
          });
          if(!nuevos.length)return;
          var set={};nuevos.forEach(function(n){set[n.h]=1;});
          // Quita de la grilla los que ya venian (para no repetirlos).
          Array.prototype.slice.call(grid.children).forEach(function(ch){
            var card=ch.classList&&ch.classList.contains('laf-card')?ch:(ch.querySelector?ch.querySelector('.laf-card'):null);
            var h=card?window.__lafCardHandle(card).toLowerCase():'';
            if(h&&set[h]){grid.removeChild(ch);}
          });
          var vacio=grid.querySelector('.lf-meds-empty');if(vacio){vacio.parentNode.removeChild(vacio);}
          // Y los pone al principio, en el mismo orden de la vista previa.
          var ref=grid.firstChild;
          nuevos.forEach(function(n){grid.insertBefore(n.card,ref);});
        });
      };
      if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',runTop);}else{runTop();}
    }
  }catch(err){}
})();
